import {Component, Input, OnInit} from '@angular/core';
import {PartnerProduct} from "../../models/partner-product.model";
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-recommendation-details-csv',
  templateUrl: './recommendation-details-csv.component.html',
  styleUrls: ['./recommendation-details-csv.component.scss'],
})
export class RecommendationDetailsCsvComponent implements OnInit {

  @Input() products: PartnerProduct[];

  constructor(private commonUtils: CommonUtils,
              private modalController: ModalController) { }

  ngOnInit() {}

  copyToClipboard() {
    const csvData = this.products.map(product => (product.idProductAttribute && product.idProductAttribute != 0)? `Produkt: (${product.partnerSystemId}_${product.idProductAttribute}) ${product.name}` : `Produkt: (${product.partnerSystemId}) ${product.name}`).join('\n');
    const text = '===*===\nZalecone produkty Vet Planet: \n'+ csvData + '\n===*===';
    navigator.clipboard.writeText(text).then(() => {
      this.commonUtils.presentInfoToast('Dane skopiowane do schowka. Wklej je do zaleceń wizyty aby przesłać je użytkownikowi aplikacji Vetineo.');
      this.modalController.dismiss();

    }).catch(err => {
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas kopiowania');
    });
  }

  getProductId(product: any) {
   return  (product.idProductAttribute && product.idProductAttribute != 0) ? `${product.partnerSystemId}_${product.idProductAttribute}`: product.partnerSystemId;
  }
}
